import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CUSTOMER_USER_DETAIL, CUSTOMER_USER_DETAIL_SUCCESS, CUSTOMER_USER_DETAIL_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getCustomerUserDetail({ payload }) {
  try {
    const { clientId, programId, urlParams } = payload;
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/clients/${clientId}/programs/${programId}/configs`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: CUSTOMER_USER_DETAIL_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CUSTOMER_USER_DETAIL_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CUSTOMER_USER_DETAIL_ERROR, payload: error });
  }
}

export function* watchCustomerUserDetail() {
  yield takeEvery(CUSTOMER_USER_DETAIL, getCustomerUserDetail);
}

function* watchCustomerUserDetailSaga() {
  yield all([fork(watchCustomerUserDetail)]);
}

export default watchCustomerUserDetailSaga;
